import {
    DIC
} from '@/const/dic'
import {
    validateChinese,
    validateCapitalUnderline
} from '@/util/validate'
import {baseUrl} from '@/config/env';


const validateName = (rule, value, callback) => {
    if (!validateChinese(value) || value.length > 30 || value.length < 1) {
        callback(new Error('部门名称为1-30位中文'))
    } else {
        callback();
    }
}

const validateCode = (rule, value, callback) => {
    if (!validateCapitalUnderline(value) || value.length > 30 || value.length < 1) {
        callback(new Error('部门编号为1-30位大写字母加下划线组成'))
    } else {
        callback();
    }
}
export const departmentTableOption = {
    align: "center",
    menuAlign: "center",
    headerAlign: "center",
    border: true,
    expand: false,
    stripe: false,
    showHeader: true,
    // align: 'center',
    index: false,
    selection: true,
    menu: true,
    page: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    viewBtn: true,
    menuWidth: '300',
    labelWidth: '200',
    defaultSort: {
        prop: 'createTime',
        order: 'descending'
    },
    column: [{
            label: "部门编号",
            prop: "code",
            placeholder: "请输入部门编号",
            search: true,
            editDisabled: true,
            type: 'input',
            // rules: [{
            //     required: true,
            //     trigger: "blur",
            //     validator: validateCode
            // }]
        },{
            label: "部门名称",
            prop: "name",
            placeholder: "请输入部门名称",
            search: true,
            editDisabled: true,
            type: 'input',
            rules: [{
                required: true,
                trigger: "blur",
                validator: validateName
            }]
        },
        {
            label: "上级部门",
            prop: "superiorId",
            solt: true,
            formsolt: true
        },{
            label: "公司名称",
            prop: "company",
            addVisdiplay: false,
            editVisdiplay: false,
        },
        {
            label: "负责人",
            prop: "dutyStuff",
            solt: true,
            formsolt: true
        },
        // {
        //     label: "部门单次加分上限",
        //     prop: "transDepartAddMax",
        //     placeholder: "其他部门负责人针对本部门员工的单次加分上限",
        //     type: 'input',
        //     hide: true,
        //     rules: [{
        //         required: true,
        //         trigger: "blur",
        //         message: "其他部门负责人针对本部门员工的单次加分上限"
        //     }]
        // },
        // {
        //     label: "部门单次减分上限",
        //     prop: "transDepartSubMax",
        //     placeholder: "其他部门负责人针对本部门员工的单次减分上限",
        //     type: 'input',
        //     hide: true,
        //     rules: [{
        //         required: true,
        //         trigger: "blur",
        //         message: "其他部门负责人针对本部门员工的单次减分上限"
        //     }]
        // },
        // {
        //     label: "员工单次加分上限",
        //     prop: "departAddMax",
        //     placeholder: "本部门针对员工的单次加分上限",
        //     type: 'input',
        //     hide: true,
        //     rules: [{
        //         required: true,
        //         trigger: "blur",
        //         message: "本部门针对员工的单次加分上限"
        //     }]
        // },
        // {
        //     label: "员工单次减分上限",
        //     prop: "departSubMax",
        //     placeholder: "本部门针对员工的单次减分上限",
        //     type: 'input',
        //     hide: true,
        //     rules: [{
        //         required: true,
        //         trigger: "blur",
        //         message: "本部门针对员工的单次减分上限"
        //     }]
        // },
        {
            label: "菜单权限",
            prop: "menuIds",
            solt: true,
            hide: true,
            formsolt: true,
            span: 24
        },
        {
            label: "创建时间",
            prop: "createTime",
            type: "datetime",
            sortable: true,
            format: "yyyy-MM-dd HH:mm:ss",
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "创建人",
            prop: "createBy",
            type: "input",
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "状态",
            prop: "status",
            type: "radio",
            addVisdiplay: false,
            editVisdiplay: false,
            dicData: DIC.STATUS_STATE_MODEL
        },
        {
            label: "更新时间",
            prop: "updateTime",
            type: "datetime",
            format: "yyyy-MM-dd HH:mm:ss",
            hide: true,
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "更新人",
            prop: "updateBy",
            type: "input",
            hide: true,
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "是否删除",
            prop: "deleteFlag",
            type: "radio",
            hide: true,
            addVisdiplay: false,
            editVisdiplay: false,
            dicData: DIC.DELETE_FLAG
        },
        {
            label: "备注",
            prop: "remarks",
            type: "textarea",
            hide: true,
            max: 255
        }


    ]
};